// extracted by mini-css-extract-plugin
module.exports = {"appLayout":"App_appLayout__Awmbh","warningLayout":"App_warningLayout__XU-e9"};